import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import T from 'prop-types';

import Animation from '../../../../../components/Animation';

const documentBody = document.body;

const handlePreventScroll = (action) => {
  documentBody.classList[action]('noscroll');
};

const ReportFormWrapper = ({
  show,
  children,
  isMobileMode,
}) => {
  if (show && !isMobileMode) return children;

  useEffect(() => {
    handlePreventScroll(show ? 'add' : 'remove');

    return () => handlePreventScroll('remove');
  }, [show]);

  return createPortal((
    <Animation show={show} animationType="slide-in-out-right">
      <div className="report-form-modal">
        {children}
      </div>
    </Animation>
  ), documentBody);
};

ReportFormWrapper.propTypes = {
  children: T.node.isRequired,
  show: T.bool.isRequired,
  isMobileMode: T.bool.isRequired,
};

export default ReportFormWrapper;